// The time presets (24 hours … All time), shared by Results' segment bar and
// Overview. Shortcuts, not a second control: the caller writes the same time
// chip a filter would (time-chip.ts `presetPatch`) and passes back which
// preset that chip equals.

import { Button } from "@pej/kore/components";
import { PRESETS, type Preset } from "./time-chip";

export function TimePresets({ selected, onPreset }: { selected: Preset | null; onPreset: (preset: Preset) => void }) {
    return (
        <fieldset aria-label="Time" className="flex shrink-0 gap-1">
            {PRESETS.map((preset) => (
                <Button
                    key={preset.key}
                    type="button"
                    size="sm"
                    variant={selected === preset.key ? "outline" : "ghost"}
                    aria-pressed={selected === preset.key}
                    className="aria-pressed:bg-kore-surface-sunken"
                    onClick={() => onPreset(preset.key)}
                >
                    {preset.label}
                </Button>
            ))}
        </fieldset>
    );
}
